<div class="dialog-container">
  <div class="icon-success">&#10003;</div>
  <h2 class="text-blue-theme-color font-semibold text-lg">
    Email Sent! Check your inbox
  </h2>
  <p>
    We've sent a secure password reset link to your email address. Sent to:
    <a class="text-blue" href="mailto:{{ data.email }}">{{ data.email }}</a>
  </p>

  <div class="steps">
    <div>
      <p
        class="bg-blue-theme-color rounded-full text-white-color min-w-[21px] flex items-center justify-center aspect-square"
      >
        1
      </p>
      <p class="text-blue-theme-color">
        Check your email inbox (and spam folder)
      </p>
    </div>
    <div>
      <p
        class="bg-blue-theme-color rounded-full text-white-color min-w-[21px] flex items-center justify-center aspect-square"
      >
        2
      </p>
      <p class="text-blue-theme-color">
        Click the "Reset Password" link in the email
      </p>
    </div>
    <div>
      <p
        class="bg-blue-theme-color rounded-full text-white-color min-w-[21px] flex items-center justify-center aspect-square"
      >
        3
      </p>
      <p class="text-blue-theme-color">Create a new secure password</p>
    </div>
  </div>

  <button
    *ngIf="!countdownCompleted"
    class="rounded-[12px] bg-none border border-[#D8DFE7] text-[12px] px-2 py-1"
    disabled
  >
    Resend available in {{ countdown }}s
  </button>

  <div class="actions">
    <button
      class="border border-blue-theme-color"
      mat-stroked-button
      mat-dialog-close
    >
      Got it
    </button>

    <!-- Resend Button: enabled only after countdown ends -->
    <button
      mat-button
      [disabled]="!countdownCompleted"
      (click)="onResendEmail()"
      [ngClass]="{
        'bg-blue-theme-color text-white-color': countdownCompleted,
        'bg-gray-color': !countdownCompleted || isResending
      }"
    >
      {{ isResending ? "Resending..." : "Resend Email" }}
    </button>
  </div>
</div>
